import Component from '@glimmer/component';
import { service } from '@ember/service';
import DataIndicator from 'tio-employee/components/reimagined/data-indicator';
import type { DataSource } from 'tio-employee/components/reimagined/data-indicator';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type { DataSourceInfo, LiveTasData } from 'tio-employee/services/reimagined-data';
import { t } from 'ember-intl';
import Text from 'tio-reimagined/components/text';
import type TasApplicationModel from 'tio-data/models/tas-application';
import ApplicationWizard from 'tio-employee/components/reimagined/tas/application-wizard';
import AlertBanner from 'tio-reimagined/components/alert-banner';

interface TasApplicationTypeTwoModel {
  tasData: LiveTasData;
  tasUsedAmount: { yearToDate: number; isLiveData: boolean };
  dataSourceInfo: DataSourceInfo;
  applicationId: string;
  applicationType: string;
  application: TasApplicationModel;
}

interface TasApplicationTypeTwoSignature {
  Args: {
    model: TasApplicationTypeTwoModel;
  };
}

export default class CareerPathwaysTasApplicationTypeTwoNew extends Component<TasApplicationTypeTwoSignature> {
  @service declare reimaginedData: ReimaginedDataService;

  get isDemoMode() {
    return this.reimaginedData.isDemoMode;
  }

  get tasSource(): DataSource {
    if (this.isDemoMode) return 'demo';
    return this.args.model.tasData.isLiveData ? 'live' : 'placeholder';
  }

  get programTemplate() {
    return this.args.model.application.tasProgramInstance?.tasProgramTemplate;
  }

  <template>
    <DataIndicator
      @source={{this.tasSource}}
      @showBadge={{true}}
      @dataSourceId="tas-application-type-two-new"
    >
      {{#if this.programTemplate}}
        <ApplicationWizard
          @application={{@model.application}}
          @applicationType="type-two"
          @programTemplate={{this.programTemplate}}
        />
      {{else}}
        <AlertBanner @intent="warning">
          <Text @size="sm">{{t "tuition_assistance.reimagined.wizard.loading_error"}}</Text>
        </AlertBanner>
      {{/if}}
    </DataIndicator>
  </template>
}
